// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"8e6d84a5","545":"1b6b00ea","787":"caae03e1"}[chunkId] + ".chunk.js";
};